/**
 * Production identity linking contracts (Phase 3B.2).
 * Shared by admin-api and admin-web UI — no zod (web-safe).
 */
export const LINK_STATUSES = ['proposed', 'confirmed', 'retired', 'rejected'];
export const LINK_CONFIDENCES = ['high', 'medium', 'low', 'conflict', 'manual'];
export const LINK_ROLES = ['primary', 'historical', 'note'];
export const PRODUCTION_CLASSIFICATIONS = ['unknown', 'real', 'test', 'developer'];
export const EXTERNAL_ENTITY_TYPES = [
    'TENANT',
    'BRANCH',
    'UPDATE_CUSTOMER',
    'UPDATE_DEVICE',
    'LICENSE_DEVICE',
    'OFFLINE_LICENSE',
    'OWNER_ACCOUNT',
];
export const EXTERNAL_SYSTEMS = ['quds_pos_cloud', 'quds_updater', 'quds_licensing', 'quds_owner_mobile'];
/** Cheap / full business↔production link status for list and details. */
export const PRODUCTION_LINK_STATUSES = ['Linked', 'Partially Linked', 'Not Linked', 'Conflict'];
export const CANDIDATE_TABS = ['candidates', 'conflicts', 'unmatched', 'excluded', 'linked'];
export const EVIDENCE_CODES = ['H1', 'H2', 'H3', 'H4', 'H5', 'M1', 'M2', 'M3', 'L1', 'C1', 'C2', 'C3', 'X1'];
export const RULE_VERSION = 1;
//# sourceMappingURL=production-linking.js.map